import { render, staticRenderFns } from "./MapasIndex.vue?vue&type=template&id=0c97584c"
import script from "./MapasIndex.vue?vue&type=script&lang=js"
export * from "./MapasIndex.vue?vue&type=script&lang=js"
import style0 from "./MapasIndex.vue?vue&type=style&index=0&id=0c97584c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports